import React from 'react'
import Empty from 'assets/images/svg/empty_screen.svg'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NoData = ({packages = 'generall',withButton = false,isDiscreption=true}) => {
  const { t } = useTranslation("browse-apps");
  let titleMsg = packages +'-EmptyTitle';
  let infoMsg = packages +'-EmptyInfo';
  return (
    <div className="noData">
    <img src={Empty} alt="Empty" />
    <h2>{t(`emptyMessage.${[titleMsg]}`)}</h2>
   {isDiscreption && ( <p>{t(`emptyMessage.${[infoMsg]}`)}</p>)}
    {withButton && (<Link to={packages === 'products'? `/browse-apps`:`#`} className='btn-White'>{packages === 'products' ? t('mainTitle') :  t('emptyMessage.ticket-new')}</Link>)}

</div>
  )
}

export default NoData